<template>
    <v-app-bar app dense color="info" style="color:#fff;">
      
      <v-btn icon style="color:#fff;" v-if="isChildRoute" @click="previousPage">
      <v-icon>mdi-keyboard-backspace</v-icon>
     </v-btn>
      <v-toolbar-title @click="goHome" style="padding-left: 0px;">Smart Collector</v-toolbar-title>
  
      <v-spacer></v-spacer>
  
      <v-btn icon style="color:#fff;" @click="goHome" v-if="isChildRoute">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn icon style="color:#fff;"  @click="Refresh()" >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
 
  
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-avatar size="36" class="mr-2" v-on="on"  style="    left: 1em !important;">
         
            <img :src="require('@/assets/images/user.png')" />
          </v-avatar>
        </template>
        <v-list>
          <v-list-item style="min-height:35px;background:#2196f3 ; font-size:13px;color:#fff!important;" >
            <v-list-item-title>{{UserObject.username}}</v-list-item-title>
          </v-list-item>
          <v-list-item  style="min-height:35px;" @click="Logout">
            <v-list-item-title >Logout</v-list-item-title>
          </v-list-item>
          <v-list-item @click="gosettings" style="min-height:35px;">
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </template>
  <script>
  export default {
    data() {
      return {
        Name: "Smart Collector",
        userDetails:[],
   
        imageuser: '/assets/images/user.png',
        UserObject:{}
      };
    },
    created(){
           
              
    },
    mounted()
    {
        this.UserObject = JSON.parse( localStorage.getItem('User'))
    },
    methods: {
      goHome() {
        this.$router.push("Dashboard");
      },
      previousPage()
      {
        window.history.back();
      },
      gosettings()
      {
        this.$router.push("BasicSettings");
      },
      Logout()
      {
         localStorage.removeItem("Token");
         localStorage.removeItem("barcode");
         localStorage.removeItem("GetPrimaryCurrency");
         localStorage.removeItem("PermissionObject");
         localStorage.removeItem("PriceGroupId");
         localStorage.removeItem("symbol");
         localStorage.removeItem("SystemBranch");
         localStorage.removeItem("Uid");
         localStorage.removeItem("User");
         this.$router.push("/login");
      },
      Refresh()
      {
        window.location.reload()
      }
    },
    computed: {
      isChildRoute() {
        return this.$route.path !== '/';
      },
    },
    
    
  };
  </script>
  